import { defineComponent as _defineComponent } from 'vue'
import BuilderEstimatorHouseLightboxImages from "./BuilderEstimatorHouseLightboxImages.vue";
  import BuilderEstimatorHouseCustomizeSlider from "./BuilderEstimatorHouseCustomizeSlider.vue";

  import type { HouseDesignInterface } from "@/types/HouseDesignInterface";

  interface ColorSelection {
    color: string;
    id: number;
    name: string;
  }

  interface Props {
    showFloorplan: boolean;
    sliderImages: string[];
    isImageFloorplanModalOpen: boolean;
    zoom: number;
    isDesktop: boolean;
    showColorsControls: boolean;
    showExitInteriorsButton: boolean;
    getColorsSelection: ColorSelection[];
    selectedHouseDesign?: HouseDesignInterface;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorHouseCarousel',
  props: {
    showFloorplan: { type: Boolean },
    sliderImages: {},
    isImageFloorplanModalOpen: { type: Boolean },
    zoom: {},
    isDesktop: { type: Boolean },
    showColorsControls: { type: Boolean },
    showExitInteriorsButton: { type: Boolean },
    getColorsSelection: {},
    selectedHouseDesign: {}
  },
  emits: ["updateZoom", "closeImageModal", "exitInteriors", "selectColor"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  

  const emit = __emit;

  const onSelectColor = (color: ColorSelection) => {
    emit("selectColor", color);
  };

  const updateZoom = (zoom: number) => {
    emit("updateZoom", zoom);
  };

  const closeImageModal = () => {
    emit("closeImageModal");
  };

  const exitInteriors = () => {
    emit("exitInteriors");
  };

const __returned__ = { emit, onSelectColor, updateZoom, closeImageModal, exitInteriors, BuilderEstimatorHouseLightboxImages, BuilderEstimatorHouseCustomizeSlider }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})